import React, { useEffect, useState } from 'react';
import { StyleSummary } from '../../../lib/clothingBrowseApi';
import ProductCard from './ProductCard';
import QuickLook from './QuickLook';

const Skeleton: React.FC = () => (
  <div className="rounded-2xl bg-white animate-pulse">
    <div className="aspect-[4/5] rounded-t-2xl bg-[#ececec]" />
    <div className="p-4 space-y-2">
      <div className="h-2.5 w-1/3 rounded bg-[#ececec]" />
      <div className="h-3.5 w-3/4 rounded bg-[#ececec]" />
      <div className="h-3 w-1/2 rounded bg-[#ececec]" />
    </div>
  </div>
);

interface ProductGridProps {
  styles: StyleSummary[];
  loading: boolean;
  pageSize: number;
}

const ProductGrid: React.FC<ProductGridProps> = ({ styles, loading, pageSize }) => {
  const [openCode, setOpenCode] = useState<string | null>(null);

  // Close the drawer whenever the result set changes
  useEffect(() => { setOpenCode(null); }, [styles]);

  const openStyle = styles.find((s) => s.style_code === openCode) ?? null;

  return (
    <>
      <div className={`grid grid-cols-2 md:grid-cols-3 2xl:grid-cols-4 gap-x-4 gap-y-6 md:gap-x-5 md:gap-y-8 transition-opacity duration-200 ${loading && styles.length ? 'opacity-60' : ''}`}>
        {loading && !styles.length && Array.from({ length: pageSize }, (_, i) => <Skeleton key={i} />)}

        {styles.map((s) => (
          <ProductCard
            key={s.style_code}
            style={s}
            active={s.style_code === openCode}
            onQuickLook={() => setOpenCode(openCode === s.style_code ? null : s.style_code)}
          />
        ))}
      </div>

      {/* Drawer, so opening a quick look no longer reflows the grid under the
          customer's cursor or pushes the row they were reading down the page. */}
      {openStyle && <QuickLook style={openStyle} onClose={() => setOpenCode(null)} />}
    </>
  );
};

export default ProductGrid;
